const components = {
    MuiButton: {
        styleOverrides: {
            textPrimary: ({ theme }) => ({      // variant='text' + color='primary'
                color: theme.palette.grey[500], // state='enabled'
                '&:hover': {
                    color: theme.palette.grey[500],
                    backgroundColor: theme.palette.grey[50]
                },
            }),
            textSizeSmall: {
                paddingRight: '10px',
                paddingLeft: '10px'
            },
            textSizeMedium: {
                paddingRight: '16px',
                paddingLeft: '16px'
            },
            textSizeLarge: {
                paddingRight: '22px',
                paddingLeft: '22px'
            },
            sizeSmall: {
                '& .MuiButton-startIcon': {
                    marginRight: 4,
                },
                '& .MuiButton-endIcon': {
                    marginLeft: 4,
                }
            },
            sizeMedium: {
                '& .MuiButton-startIcon': {
                    marginRight: 4,
                },
                '& .MuiButton-endIcon': {
                    marginLeft: 4,
                }
            }
        },
        contained: ({ theme }) => ({ // variant='contained'
            boxShadow: 'none',
            backgroundImage: 'none',
            '&:focus': { // state='focused'
                outline: 'none',
                boxShadow: 'none',
            },
            '&.Mui-disabled': { // state='disabled'
                color: theme.palette.common.white
            }
        }),
    },
    MuiTooltip: {
        styleOverrides: {
            tooltip: {
                backgroundColor: '#000',
                fontSize: '12px'
            },
            arrow: {
                color: '#000'
            },
        },
    },
    MuiChip: {
        styleOverrides: {
            label: {
                fontWeight: 500
            },
        },
    }
};
  
export default components;
